export default __webpack_public_path__ + "static/media/dashboard.4b2b35fb.svg";